import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';
import { fonts, fontSizes, fontWeights, letterSpacings, lineHeights } from './fonts';
import { radii, shadows, sizes, space } from './foundations';
import { components } from './components';
import { styles } from './styles';

export const theme = extendTheme({
  config: { initialColorMode: 'light', useSystemColorMode: false },
  colors,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  radii,
  shadows,
  space,
  sizes,
  styles,
  components,
});
